import Cookies from 'universal-cookie';

const usePartner = (): {
  hpChannel?: string;
  hpChannelGroup?: string;
} => {
  const cookieStore = new Cookies();

  return {
    hpChannelGroup: cookieStore.get('hpChannelGroup'),
    hpChannel: cookieStore.get('hpChannel'),
  };
};

export default usePartner;
